import { useId } from 'react';
import { fileInput, input, label } from './adminUi';
import RichTextEditor from './RichTextEditor';

export default function ProductForm({ product, onChange, onUploadImage, uploadHint }) {
  const descriptionFieldId = useId();

  function set(field, value) {
    onChange({ ...product, [field]: value });
  }

  const gridClass = 'grid w-full gap-6 sm:grid-cols-2';

  return (
    <div className={gridClass}>
      <label className={`${label} sm:col-span-2`}>
        Title
        <input className={input} value={product.title} onChange={(e) => set('title', e.target.value)} />
      </label>
      <div className={`${label} sm:col-span-2`}>
        <label className="block" htmlFor={descriptionFieldId}>
          Description
        </label>
        <span className="mb-2 mt-0.5 block text-[11px] font-normal text-neutral-500">
          Bold, lists, and links. Shown on the public product card (sanitized).
        </span>
        <RichTextEditor
          key={product.id}
          value={product.description || ''}
          onChange={(html) => set('description', html)}
          editorMinHeight="10rem"
        />
      </div>

      <div className="sm:col-span-2 rounded-xl border border-neutral-200/90 bg-neutral-50/80 p-4 sm:p-5">
        <p className="mb-3 text-xs font-semibold uppercase tracking-wide text-neutral-500">Image</p>
        <label className={`${label} mb-0`}>
          Upload (Cloudinary)
          <input
            type="file"
            accept="image/*"
            className={fileInput}
            onChange={(e) => onUploadImage?.(e.target.files?.[0])}
          />
          {uploadHint ? (
            <span className="mt-1.5 block text-[11px] text-neutral-500">{uploadHint}</span>
          ) : (
            <span className="mt-1.5 block text-[11px] text-neutral-500">
              Upload fills the URL below automatically.
            </span>
          )}
        </label>
        <label className={`${label} mt-4`}>
          Image URL
          <input
            className={`${input} mt-1.5 bg-white text-neutral-700`}
            value={product.image}
            readOnly
            placeholder="Upload a file above"
          />
        </label>
        {product.image ? (
          <button
            type="button"
            onClick={() => set('image', '')}
            className="mt-3 text-xs font-medium text-neutral-600 underline decoration-neutral-300 hover:text-neutral-900"
          >
            Clear image
          </button>
        ) : null}
        <label className={`${label} mt-4`}>
          Alt text
          <input className={input} value={product.alt} onChange={(e) => set('alt', e.target.value)} />
        </label>
      </div>
    </div>
  );
}
